import React from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

import BarChart from "./BarChart";
import PieChart from "./PieChart";

const Dashboard = ({ stats = [], charts = [] }) => {
  return (
    <div className="container-fluid p-4">
      {/* Statistic Cards */}
      <div className="row g-4 mb-4">
        {stats.map((stat, idx) => (
          <div key={idx} className="col-12 col-sm-6 col-lg-3">
            <div
              className={`card border-${stat.color} shadow-sm stat-card`}
              style={{
                animation: `fadeUp 0.6s ease ${
                  Math.min(idx, 5) * 0.1
                }s forwards`,
                opacity: 0,
              }}
            >
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  {/* <h5 className={`text-${stat.color} mb-1`}>{stat.title}</h5> */}
                  <div className="d-flex gap-1">
                    <h5 className={` mb-1`}>{stat.title}</h5>
                    <div title={stat?.infoTitle}>{stat?.info}</div>
                  </div>
                  <div className={`dashboard-card-fs text-${stat.color}`}>
                    {stat.value}
                  </div>
                  {stat.change !== undefined && (
                    <small
                      className={
                        stat.change >= 0 ? "text-success" : "text-danger"
                      }
                    >
                      {stat.change >= 0 ? <FaArrowUp /> : <FaArrowDown />}{" "}
                      {Math.abs(stat.change)}%
                    </small>
                  )}
                </div>
                <div className={`display-6 text-${stat.color}`}>
                  {stat.icon}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="row g-4">
        {charts.map((chart, idx) => (
          <div key={idx} className="col-12 col-lg-6">
            <div className="card shadow-sm p-3">
              {chart.type === "pie" ? (
                <PieChart {...chart} />
              ) : (
                <BarChart {...chart} />
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Animation Styles */}
      <style>{`
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .stat-card {
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .stat-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </div>
  );
};

export default Dashboard;
